import { createApp } from "vue";
import App from "./App.vue";
const app = createApp(App);
import Toast from "vue-toastification";
import router from "./router";
import store from "./store";
import "@/styles";
import useImports from "@/imports";
useImports(app);
app.use(store);
app.use(router);
app.use(Toast, {});
app.mount("#app");
